export enum CompareOperator {
    GREATERTHAN = 1,
    GREATERTHANEQUALTO = 2,
    LESSTHAN = 3,
    LESSTHANEQUALTO = 4,
    EQUALS = 5,
    BETWEEN = 6,
}
